import { ISubAsset } from '@interface/marketplace/SubAsset';
import { IAction } from '@/interface/IAction';
import { INextPageContext } from '@/interface/INextPageContext';

export const actionType = Object.freeze({
    GET_ACCOUNT_BALANCE_SUMMARY: 'balance-asset.get-account-balance-summary',
    SET_ACCOUNT_BALANCE_SUMMARY: 'balance-asset.set-account-balance-summary',

    FETCH_TRANSCATION_RECORDS: 'balance-asset.fetch-transaction-records',
    SET_TRANSACTION_RECORDS: 'balance-asset.set-transaction-records',

    FETCH_DEPOSIT_WITHDRAWAL_RECORDS:
        'balance-asset.fetch-deposit-withdrawal-records',
    SET_DEPOSIT_WITHDRAWAL_RECORDS:
        'balance-assset.set-deposit-withdrawal-records',

    WITHDRAWAL: 'balance-asset.withdrawal',

    FETCH_FUNDER_CONTRIBUTIONS: 'balance-asset.fetch-funder-contributions',
    SET_FUNDER_CONTRIBUTIONS: 'balance-asset.set-funder-contributions',

    FETCH_AWAITING_REPAYMENT_RECORDS:
        'balance-asset.fetch-awaiting-repayment-records',
    SET_AWAITING_REPAYMENT_RECORDS:
        'balance-asset.set-awaiting-repayment-records',

    FETCH_PAST_AUCTIONS: 'balance-asset.fetch-past-auctions',
    SET_PAST_AUCTIONS: 'balance-asset.set-past-auctions',
});

export function getAccountBalanceSummary(setIsGettingBalanceSummary): IAction {
    const payload = {
        setIsGettingBalanceSummary,
    };
    return {
        type: actionType.GET_ACCOUNT_BALANCE_SUMMARY,
        payload,
    };
}

export function setAccountBalanceSummary(accountSummary) {
    return {
        type: actionType.SET_ACCOUNT_BALANCE_SUMMARY,
        payload: accountSummary,
    };
}

export function fetchTransactionRecords(
    startDate,
    endDate,
    currency,
    setIsFetchingTxnRecords,
): IAction {
    const payload = {
        startDate,
        endDate,
        currency,
        setIsFetchingTxnRecords,
    };
    return {
        type: actionType.FETCH_TRANSCATION_RECORDS,
        payload,
    };
}

export function setTransactionRecords(txnRecords) {
    return {
        type: actionType.SET_TRANSACTION_RECORDS,
        payload: txnRecords,
    };
}

export function fetchDepositWithdrawalRecords(
    startDate,
    endDate,
    currency,
    setIsFetchingDepositWithdrawalRecords,
): IAction {
    const payload = {
        startDate,
        endDate,
        currency,
        setIsFetchingDepositWithdrawalRecords,
    };
    return {
        type: actionType.FETCH_DEPOSIT_WITHDRAWAL_RECORDS,
        payload,
    };
}

export function setDepositWithdrawalRecords(depositWithdrawalRecords) {
    return {
        type: actionType.SET_DEPOSIT_WITHDRAWAL_RECORDS,
        payload: depositWithdrawalRecords,
    };
}

export function withdrawal(
    accountId,
    withdrawalAmount,
    currency,
    setIsSendingWithdrawalRequest,
    refreshDepositWithdrawalRecords,
) {
    return {
        type: actionType.WITHDRAWAL,
        payload: {
            withdrawalAmount,
            currency,
            setIsSendingWithdrawalRequest,
            refreshDepositWithdrawalRecords,
        },
    };
}

export function fetchFunderContributions(
    currencies,
    isRemitted: boolean,
    setIsFetchingContributions: Function,
): IAction {
    const payload = {
        currencies,
        isRemitted,
        setIsFetchingContributions,
    };
    return {
        type: actionType.FETCH_FUNDER_CONTRIBUTIONS,
        payload,
    };
}

export function setFunderContributions(contributions) {
    return {
        type: actionType.SET_FUNDER_CONTRIBUTIONS,
        payload: contributions,
    };
}

export function fetchAwaitingRepaymentRecords(
    setIsFetchingAwaitingRecords: Function,
) {
    return {
        type: actionType.FETCH_AWAITING_REPAYMENT_RECORDS,
        payload: { setIsFetchingAwaitingRecords },
    };
}

export function setAwaitingRepaymentRecords(records) {
    return {
        type: actionType.SET_AWAITING_REPAYMENT_RECORDS,
        payload: records,
    };
}

export function fetchPastAuctionRecords(payload) {
    return {
        type: actionType.FETCH_PAST_AUCTIONS,
        payload,
    };
}

export function setPastAuctions(records) {
    return {
        type: actionType.SET_PAST_AUCTIONS,
        payload: records,
    };
}
